/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const UPGRADE_AVAILABLE = (
    <FormattedMessage
        id='command_center_tooltip.upgrade_available'
        defaultMessage={'Готов к модернизации'}
    />
)

export const BUILDING_INFO = (level) => {
    return (
        <FormattedMessage
            id='command_center_tooltip.building_info'
            defaultMessage={'Позволяет модернизировать все строения до {level} уровня'}
            values={{
                level,
            }}
        />
    )
}



// WEBPACK FOOTER //
// ./components/CommandCenterTooltip/constants.jsx